import React from 'react';
import './App.css';
import "@blueprintjs/core/lib/css/blueprint.css"
import "@blueprintjs/icons/lib/css/blueprint-icons.css"
import {BrowserRouter as Router, Route} from "react-router-dom";
import AlbumViewerPage from "./pages/album-viewer-page";
import TrendingPage from "./pages/trending-page";
import {Provider} from "react-redux";
import {applyMiddleware, createStore} from "redux";
import thunk, {ThunkMiddleware} from "redux-thunk";
import {doRefreshUserData} from "./store/system-actions";
import {SystemActions} from "./store/system-types";
import {TopBar} from "./components/top-bar";
import {rootReducer, RootState} from "./reducers/root-reducer";
import {FileUploadActions} from "./store/file-upload-types";

function App() {

    let store = createStore(rootReducer, applyMiddleware(thunk as ThunkMiddleware<RootState, SystemActions | FileUploadActions>))
    store.dispatch(doRefreshUserData()).finally()

    return (
        <Provider store={store}>
            <Router>
                <div className="App">
                    <TopBar/>
                    <Route path="/album_viewer" component={AlbumViewerPage}/>
                    <Route path="/trending" component={TrendingPage}/>
                </div>
            </Router>
        </Provider>
    )
}

export default App;